export class PriceListImportModel {
  counter: number = 0;
  priceListId: number = 0;
  numberList: number = 0;
  articleCode: number = 0;
  articleName: string = "";
  unitValue: number = 0;
  rateDiscount: number = 0;
  swManual: boolean = false;

  constructor(counter: number = 0,
    priceListId: number = 0,
    numberList: number = 0,
    articleCode: number = 0,
    articleName: string = "",
    unitValue: number = 0,
    rateDiscount: number = 0,
    swManual: boolean = false
  ) {
    this.counter = counter;
    this.priceListId = priceListId;
    this.numberList = numberList;
    this.articleCode = articleCode;
    this.articleName = articleName;
    this.unitValue = unitValue;
    this.rateDiscount = rateDiscount;
    this.swManual = swManual;
  }
}